import { Box, List, ListItem, ListItemButton, ListItemText, Paper, Badge } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { RoutesEnum } from 'src/shared/models/enums/routes.enum';
import { useMemberUpdatesBadge } from 'src/modules/member/hooks/useMemberUpdatesBadge';
import { useEInvoiceApplicationsBadge } from 'src/modules/invoice/hooks/useEInvoiceApplicationsBadge';
import { useUnmatchedPaymentsBadge } from 'src/modules/invoice/hooks/useUnmatchedPaymentsBadge';
import { useAutogiroUnlinkedBadge } from 'src/modules/invoice/hooks/useAutogiroUnlinkedBadge';
import { useUnaccountedPaymentsBadge } from 'src/modules/invoice/hooks/useUnaccountedPaymentsBadge';
import { HeaderSubTitle } from './atoms/headerSubTitle';

export const TodoWidget = () => {
  const { t } = useTranslation(['dashboard']);

  const memberUpdates = useMemberUpdatesBadge();
  const [eInvoiceApplications] = useEInvoiceApplicationsBadge();
  const unmatchedPayments = useUnmatchedPaymentsBadge();
  const [unlinkedMandates] = useAutogiroUnlinkedBadge();
  const unaccountedPayments = useUnaccountedPaymentsBadge();

  const items = [
    { label: t('dashboard:todoWidget.memberUpdates'), count: memberUpdates, route: RoutesEnum.MemberUpdates },
    { label: t('dashboard:todoWidget.eInvoiceApplications'), count: eInvoiceApplications, route: RoutesEnum.EInvoiceApplications },
    { label: t('dashboard:todoWidget.unmatchedPayments'), count: unmatchedPayments, route: RoutesEnum.IncomingBankPayment },
    { label: t('dashboard:todoWidget.unaccountedPayments'), count: unaccountedPayments, route: RoutesEnum.PaymentTransactions },
    { label: t('dashboard:todoWidget.unlinkedMandates'), count: unlinkedMandates, route: RoutesEnum.Autogiro, state: { filterLinked: 'unlinked' } },
  ].filter((item) => item.count > 0);

  return (
    <Paper sx={{ p: 2, mb: 2 }}>
      <HeaderSubTitle label={t('dashboard:todoWidget.header')} />
      {items.length === 0 ? (
        <Box mt={1}>
          <em>
            <HeaderSubTitle label={t('dashboard:todoWidget.nothingToDo')} colorTextSecondary />
          </em>
        </Box>
      ) : (
        <List dense disablePadding sx={{ mt: 1 }}>
          {items.map((item) => (
            <ListItem key={item.route} disablePadding divider>
              <ListItemButton component={Link} to={item.route} state={item.state} sx={{ borderRadius: 1, py: 0.5 }}>
                <ListItemText primary={item.label} />
                <Badge
                  badgeContent={item.count}
                  color='error'
                  sx={{ '& .MuiBadge-badge': { position: 'relative', transform: 'none', minWidth: 18, height: 18, fontSize: '0.7rem' } }}
                />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      )}
    </Paper>
  );
};
